import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthState from '@/states/auth.state';
import useTenantState from '@/states/tenant.state';

const Callback = () => {
  const navigate = useNavigate();
  const { handleCallback } = useAuthState();
  const { setCurrentTenant } = useTenantState();
  const { tenants } = useAuthState();
  const tenantId = localStorage.getItem('initial-tenant-id');

  useEffect(() => {
    if (tenantId && tenants && tenants.length > 0) {
      // Sync tenant state with URL
      const tenant = tenants.find(t => t.slug === tenantId);
      if (tenant) {
        setCurrentTenant(tenant);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenants, setCurrentTenant]);

  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get('code');
    const verifier = localStorage.getItem('verifier');
    if (!code || !verifier) {
      navigate('/login');
      return;
    }
    handleCallback(code, verifier)
      .then(() => {
        const redirectTo = localStorage.getItem('redirect_to');
        localStorage.removeItem('initial-tenant-id');
        localStorage.removeItem('redirect_to');

        if (redirectTo) {
          navigate(redirectTo);
        } else {
          navigate(`/${tenantId}`);
        }
      })
      .catch(error => {
        console.error('Error during callback handling:', error);
        // Handle error appropriately, e.g., show an error message or redirect to login
        navigate('/login');
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div className="flex items-center justify-center h-screen bg-gray-100">Validating your authentication...</div>;
};

export default Callback;
